export default {
    methods: {
        /**
         * Removes everything except digits
         *
         * @param {string} rawPhone
         * @returns string
         */
        getPhoneDigitsOnly (rawPhone) {
            return rawPhone?.toString()?.replace(/\D/g, '').match(/(\d{0,10})/g)[0];
        },

        getABNACNDigitsOnly (rawPhone) {
            return rawPhone?.toString()?.replace(/-/g, '').replace(/\s/g, '').match(/(\d{0,11})/g)[0];
        },

        getBsbOnly (rawPhone) {
            return rawPhone?.toString()?.replace(/-/g, '').match(/(\d{0,7})/g)[0];
        },
        getAccountDigitsOnly (rawPhone) {
            return rawPhone?.toString()?.replace(/-/g, '').match(/(\d{0,11})/g)[0];
        },

        /**
         * Formats digit based phone to x-xxxx-xxxx
         *
         * @param {string} rawPhone
         * @returns string
         */
        formatPhoneForAustralia (rawPhone) {
            if(rawPhone.toString().substring(0, 2) == "04" || rawPhone.toString().substring(0, 1) == "1" ){
                return rawPhone?.toString()?.replace(/(\d{1,4})(\d{1,3})(\d{1,3})/g, '$1-$2-$3');
            }

            return rawPhone?.toString()?.replace(/(\d{1,2})(\d{1,4})(\d{1,4})/g, '$1-$2-$3');
        },
        formatPhoneForAustraliaBySpace (rawPhone) {
            if(rawPhone.toString().substring(0, 2) == "04" || rawPhone.toString().substring(0, 1) == "1" ){
                return rawPhone?.toString()?.replace(/(\d{1,4})(\d{1,3})(\d{1,3})/g, '$1-$2-$3');
            }

            return rawPhone?.toString()?.replace(/(\d{1,2})(\d{1,4})(\d{1,4})/g, '$1-$2-$3');
        },
        estimateBudgetFormat (rawPhone) {
            return rawPhone?.toString()?.replace(/(\d{1,4})(\d{1,3})(\d{1,3})/g, '$1 $2 $3');
        },
        formatBsb(rawPhone){
            return rawPhone?.toString()?.replace(/(\d{1,3})(\d{1,4})/g, '$1-$2');
        },
        formatABNACNForAustralia (rawACN) {
            return rawACN?.toString()?.replace(/(\d{1,2})(\d{1,3})(\d{1,3})(\d{1,3})/g, '$1-$2-$3-$4');
        }
    }
  }
